export const formateResourceInfoResponse = (response) => {
    let formattedResources = [];
    response.forEach((resource) => {
        formattedResources.push({
            coCd: resource.Co_Cd,
            orgName: resource.Org_Name,
            addressLine1: resource.addr_line1,
            addressLine2: resource.addr_line2,
            countryName: resource.country_name,
            crossoverCoCd: resource.crossover_co_cd,
            crossoverOrgCd: resource.crossover_org_cd,
            crossoverOrgUserId: resource.crossover_org_user_id,
            distance: resource.distance,
            emailAddress: resource.email_addr,
            geoX: resource.geo_x,
            geoY: resource.geo_y,
            orgCd: resource.org_cd,
            orgId: resource.org_id,
            phoneNumber: resource.phone_num,
            phoneNumber2: resource.phone_num2,
            phoneNumberExt: resource.phone_num_ext,
            phoneNumberExt2: resource.phone_num_ext2,
            postalCd: resource.postal_cd,
            regionCd: resource.region_cd
        });
    });
    return formattedResources;
};
export const buildResourceLookupModalData = (resourcesInfo) => {
    const MILES = 'mi';
    let modalData = [];
    resourcesInfo.forEach((resource, index) => {
        const localModalData = {
            id: ++index,
            name: `${resource.orgName} ${resource.crossoverOrgCd}`,
            address: `${resource.addressLine1} ${resource.addressLine2} ${resource.postalCd} ${resource.countryName}`,
            contactInfo: `${formatContactNumber(resource.phoneNumber)} ${resource.emailAddress}`,
            distance: !!resource.distance ? `${resource.distance} ${MILES}` : ''
        };
        modalData.push(localModalData);
    });
    return modalData;
};
export const buildResourceAssignmentPayload = (selectedResourceInfo, assignorOrgId, shopCoCode, jobId) => {
    const assigneeDetails = {
        AssigneeCoCd: selectedResourceInfo.coCd,
        AssigneeOrgCd: selectedResourceInfo.orgCd
    };
    const reassignDetails = {
        assigneeId: selectedResourceInfo.crossoverOrgUserId,
        assignments: null,
        assignorOrgId: assignorOrgId,
        coCode: shopCoCode
    };
    return {
        AssigneeDetails: assigneeDetails,
        ReassignDetails: reassignDetails,
        jobId
    };
};
export const formatContactNumber = (phoneNumber) => {
    if (phoneNumber.length < 4)
        return phoneNumber;
    if (phoneNumber.length < 7)
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
};
export const getFormattedRepairResources = (response) => {
    let formattedResponse = [];
    response.forEach((repairResource) => {
        formattedResponse.push(Object.assign(Object.assign({}, getRepairResourceAddressMapping(repairResource.address)), { orgName: '', resourceName: repairResource.orgName, addressLine2: '', countryName: '', crossoverCoCd: '', crossoverOrgCd: '', crossoverOrgUserId: '', distance: `${repairResource.distance}`, emailAddress: repairResource.email || '', orgCd: repairResource.orgCode, orgId: '', phoneNumber: repairResource.phone || '', phoneNumber2: '', phoneNumberExt: '', phoneNumberExt2: '', regionCd: '' }));
    });
    return formattedResponse;
};
const getRepairResourceAddressMapping = (address) => {
    const repairResourceAddressMappingObject = {
        coCd: '',
        addressLine1: '',
        city: '',
        state: '',
        geoX: '',
        geoY: '',
        postalCd: ''
    };
    if (address !== null) {
        repairResourceAddressMappingObject.coCd = address.countryCode || '';
        repairResourceAddressMappingObject.addressLine1 = address.address1 || '';
        repairResourceAddressMappingObject.city = address.city || '';
        repairResourceAddressMappingObject.state = address.stateProvince || '';
        repairResourceAddressMappingObject.geoX = address.longitude ? `${address.longitude}` : '';
        repairResourceAddressMappingObject.geoY = address.latitude ? `${address.latitude}` : '';
        repairResourceAddressMappingObject.postalCd = address.postalCode || '';
    }
    return repairResourceAddressMappingObject;
};
//# sourceMappingURL=resourceLookupHelper.js.map